// src/components/Neon3DButton.js

import React, { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import './Neon3DButton.css';

const Neon3DButton = ({ onClick }) => {
  const { translations } = useContext(LanguageContext);
  return (
    <div
      className="neon3d-button-container"
      onClick={onClick}
      role="button"
      tabIndex="0"
      onKeyDown={(e) => { if (e.key === 'Enter') onClick(); }}
    >
      <svg viewBox="0 0 200 120" className="neon3d-svg" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="clip-neon">
            <text x="10" y="100" fontFamily="Arial" fontSize="100" fontWeight="bold">
              {translations.neon3DButtonText}
            </text>
          </clipPath>
        </defs>
        <rect width="200" height="120" fill="#3498db" clipPath="url(#clip-neon)" />
        <text
          x="10"
          y="100"
          fontFamily="Arial"
          fontSize="100"
          fontWeight="bold"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
        >
          {translations.neon3DButtonText}
        </text>
      </svg>
    </div>
  );
};

export default Neon3DButton;
